export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6194.31b0f32f.jpg";